import { render, staticRenderFns } from "./CandidateDetailsTalentfind.vue?vue&type=template&id=b0def394&scoped=true"
import script from "./CandidateDetailsTalentfind.vue?vue&type=script&lang=js"
export * from "./CandidateDetailsTalentfind.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetailsTalentfind.vue?vue&type=style&index=0&id=b0def394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0def394",
  null
  
)

export default component.exports